import ReactRenderer from './modules/_react-renderer'
import DealersList from './react/DealersList'
import DealersMap from './react/DealersMap'

(function(){
    ReactRenderer.registerComponent(DealersList, 'DealersList')
    ReactRenderer.registerComponent(DealersMap, 'DealersMap')
    ReactRenderer.render()
})()